import React, { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import LegalDocumentModal from './LegalDocumentModal';
import {
  PRIVACY_POLICY_CONTENT,
  TERMS_OF_SERVICE_CONTENT,
  COOKIE_POLICY_CONTENT,
  parseLegalContent,
} from '@/content/legalDocuments';
import {
  isWebReadyTenant,
  WEBREADY_LEGAL_ROUTES,
} from '@/lib/webreadyLegal';

export default function LegalDocuments() {
  const [location, setLocation] = useLocation();
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showCookieModal, setShowCookieModal] = useState(false);
  const webReady = isWebReadyTenant();

  // Open modal on legacy route (non-WebReady tenants only)
  useEffect(() => {
    if (webReady) return;
    if (location === '/privacy-policy') {
      setShowPrivacyModal(true);
    } else if (location === '/terms-of-service') {
      setShowTermsModal(true);
    }
  }, [location, webReady]);

  useEffect(() => {
    const handlePrivacyOpen = () => {
      if (webReady) {
        setLocation(WEBREADY_LEGAL_ROUTES.privacy);
        return;
      }
      setShowPrivacyModal(true);
    };
    const handleTermsOpen = () => {
      if (webReady) {
        setLocation(WEBREADY_LEGAL_ROUTES.terms);
        return;
      }
      setShowTermsModal(true);
    };
    const handleCookieOpen = () => {
      if (webReady) {
        setLocation(WEBREADY_LEGAL_ROUTES.cookies);
        return;
      }
      setShowCookieModal(true);
    };

    window.addEventListener('privacy-policy:open', handlePrivacyOpen);
    window.addEventListener('terms-of-service:open', handleTermsOpen);
    window.addEventListener('cookie-policy:open', handleCookieOpen);
    return () => {
      window.removeEventListener('privacy-policy:open', handlePrivacyOpen);
      window.removeEventListener('terms-of-service:open', handleTermsOpen);
      window.removeEventListener('cookie-policy:open', handleCookieOpen);
    };
  }, [webReady, setLocation]);

  const handlePrivacyClose = (open: boolean) => {
    setShowPrivacyModal(open);
    if (!open && location === '/privacy-policy') {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        setLocation('/');
      }
    }
  };

  const handleTermsClose = (open: boolean) => {
    setShowTermsModal(open);
    if (!open && location === '/terms-of-service') {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        setLocation('/');
      }
    }
  };

  if (webReady) {
    return null;
  }

  return (
    <>
      <LegalDocumentModal
        open={showPrivacyModal}
        onOpenChange={handlePrivacyClose}
        title="Politica de Confidențialitate"
        content={parseLegalContent(PRIVACY_POLICY_CONTENT)}
      />
      <LegalDocumentModal
        open={showTermsModal}
        onOpenChange={handleTermsClose}
        title="Termeni și Condiții"
        content={parseLegalContent(TERMS_OF_SERVICE_CONTENT)}
      />
      <LegalDocumentModal
        open={showCookieModal}
        onOpenChange={setShowCookieModal}
        title="Politica de Cookie-uri"
        content={parseLegalContent(COOKIE_POLICY_CONTENT)}
      />
    </>
  );
}
